
import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/logos/darwynn/darwynn_logo.svg"

// react-router-dom components
import {Link, useLocation, useNavigate} from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import {motion, useTransform} from "framer-motion";


import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    InputAdornment,
} from "@mui/material";

//form
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";

import { useDispatch, useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import {
    AuthActionType,
    authLogin, get_auth_info,
    get_routes, getEmailCodeSignIn, getVerificationCode,
    onErrorAlert,
    onSuccessAlert, SystemActionType
} from "../../../actions";
import { noop } from "lodash";
import LocalStorage from "../../../utils/LocalStorage";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import FramerFade from "../../../components/Animation/Fade";
import ForgetPasswordDialog from "../forget-password";
import {useTranslation} from "react-i18next";
import {LOCAL_STORAGE_ITEMS} from "../../../constants";
import {findRoutes, keyToNodeMap} from "../../../utils/globalFunction";
import PaperComponent from "../../../components/MuiDraggableDialog";
import UserPasswordChange from "../../profile/passwordSetting/UserPasswordChange";
import LoginVerification from "./LoginVerification";
import CircularProgress from "@mui/material/CircularProgress";


//style
const style= {
  img:{
    width:'120px',
    height:'40px',
    position:'absolute',
    right:'0',
    border:'2px solid grey',
    cursor:'pointer'
  }
}
const Basic = () => {
    const { t, i18n } = useTranslation();
    const nav = useNavigate()
    const schema = yup
        .object({
            username: yup.string().required(t('SignInPage.Username is required')),
            password: yup.string().min(6,t('SignInPage.Password must be more than 6 characters')).required(t('SignInPage.Password is required')),
            code:yup.string().required(t('SignInPage.Code is required')),
        })
  const {register,handleSubmit,getValues, setValue,formState: { errors }} = useForm({resolver: yupResolver(schema)});
  const [img, setImg] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [uuid, setUuid] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useDispatch()
  const verification = useSelector(state => state?.auth?.verification)
  const darkMode = useSelector(state => state?.common?.darkMode)
  const [openModal,setOpenModal] = useState(false)
  const [activeStep, setActiveStep] = useState(0);
  const [loginVerificationOpen, setLoginVerificationOpen] = useState(false)
  const [email,setEmail] = useState("")
    const [isLoading,setIsLoading] = useState(false)

    const language = useSelector(state => state?.common?.language,(prev, next) => prev === next)


    const { search } = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(search);
        const ref = params.get("redirectLink");
        try {
            // 2. 把 redirectLink 当成 URL 解析
            const innerUrl = new URL(ref);
            // 3. 从 innerUrl.searchParams 拿 ticket
            const ticket = innerUrl.searchParams.get("ticket");
            if (ref) {
                localStorage.setItem("redirectLink", innerUrl);
                localStorage.setItem("ticket", ticket);
            }
        } catch (e) {
            console.error("Invalid redirectLink:", ref);
        }
    },[search])



    useEffect(() => {

      LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.token);
      LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.role);
      LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.ownerId);
      LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.keys)
      LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.menu)
      LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.permissions)
      LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.user_roles)
      LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.lastUpdateTimestamp)
      LocalStorage.setItem('notification',true)

      dispatch({
          type:SystemActionType.Set_Card,
          payload:false
      })

    setRememberMe(!!LocalStorage.getItem('password'))
    const apiGet = async () => {
      await dispatch(getVerificationCode(noop,onCodeError))
    }
    apiGet().then()

  }, []);

  useEffect(() => {
    if(verification){
      setImg(`data:image/gif;base64,${verification?.img}`)
      setUuid(verification.uuid)
    }
  }, [verification]);

  useEffect(() => {


    if(!!rememberMe && (getValues("username")==='' || !getValues("username")) && (getValues("password")==='') || !getValues("password")){
      setValue('username',LocalStorage.getItem('sub_username'))
      setValue('password',LocalStorage.getItem('password'))
    } else if(!rememberMe){
        LocalStorage.removeItem('sub_username')
        LocalStorage.removeItem('password')
    }
  }, [rememberMe]);


  const onError = (msg) =>{
      dispatch(getVerificationCode(noop,onCodeError))
      setIsLoading(false)
      dispatch(onErrorAlert(msg))
  }

    const onCodeError = (msg) =>{

        if(msg !== 'Inner Server error'){
            dispatch(getVerificationCode(noop,onCodeError))
        }
        setIsLoading(false)
        dispatch(onErrorAlert(msg))
    }
  const onLoginSuccess = async (msg) => {
      dispatch({
          type: AuthActionType.CHANGE_LOADING,
          payload: true
      })

      await dispatch(get_auth_info(async () => {
          await dispatch(get_routes(onAuthSuccess,onError))
      }, onError))


      // await dispatch(get_routes(async () => {
      //     await dispatch(get_auth_info(onAuthSuccess,onError))
      // }, onError))


      LocalStorage.setItem('username', getValues("username"))

  }

  const onAuthSuccess = async (x,y) => {

      const keys = JSON.parse(LocalStorage.getItem('keys'))
      if(keys && keys.length > 0){
          const result = findRoutes(keys, keyToNodeMap)
          // nav(`/app${result}`)
          LocalStorage.setItem('alert', 'Log in successfully')
          window.location.href = `/app${result}`;

          // window.location.replace(`/app${result}?v=${Date.now()}`);

      } else {
          dispatch(onErrorAlert(t('You do not have any permissions assigned. Please contact the administrator')))

          setIsLoading(false)
      }


  }



  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const onSubmit = async (data) => {
    let formData = {}
    formData.uuid = uuid
    formData = { ...formData, ...data }
    if(rememberMe){
      LocalStorage.setItem('sub_username',formData.username)
      LocalStorage.setItem('password',formData.password)
    } else {
      LocalStorage.removeItem('sub_username')
      LocalStorage.removeItem('password')
    }
    setIsLoading(true)

    // await dispatch(authLogin(formData,onPasswordCorrect,onError))
      await dispatch(authLogin(formData,onLoginSuccess,onError))
  }




  const onGetEmailCodeSuccess = () => {
      setIsLoading(false)
      setLoginVerificationOpen(true)
  }


  const pathWordVariants = {
    from: {
      opacity: 0,
      pathLength: 0,
        x:-100,
    },
    to: {
      opacity: 1,
      pathLength: 1,
        x:0,
      transition: {
        duration: 2,
        ease: "easeInOut",
        delay:2,
          type: "spring", stiffness: 70
      }
    }
  };

  const pathCheckVariants = {
    from: {
      opacity: 0,
      pathLength: 1,
        pathOffset: 1,
      x: 0,
      y: 0,
      rotate:0,
        scale:0
    },
    to: {
      opacity: 1,
      pathLength: 1,
        pathOffset: 1,
        x: 0,
        y: 0,
        rotate:720,
        scale:1,
      transition: {
        duration: 1.5,
        ease: "easeInOut",
        delay:0,

      }
    }
  };

  const pathPointer = {
      from: {
          opacity: 0,
          pathLength: 1,
          pathOffset: 1,
      },
      to: {
          opacity: 1,
          pathLength: 1,
          pathOffset: 1,
          transition: {
              duration: 1,
              ease: "easeInOut",
              delay:1.5
          }
      }
  }

  return (
    // <BasicLayout >
      <React.Fragment>
          <BasicLayout image={bgImage}>
              <Grid>
                  <motion.svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="270"
                      height="150"
                      viewBox="0 0 204 58"
                      fill="none"
                  >
                      <motion.path
                          d="M10.134 50.854C10.134 50.927 10.13 51.014 10.121 51.121C10.11 51.227 10.099 51.342 10.086 51.464L6.55302 51.684C6.55302 51.969 6.58304 52.215 6.64104 52.424C6.69904 52.634 6.79203 52.805 6.92003 52.94C7.04803 53.074 7.22004 53.177 7.43204 53.244C7.64404 53.312 7.90904 53.345 8.22304 53.345C8.51304 53.345 8.80703 53.313 9.10703 53.249C9.40603 53.184 9.65603 53.104 9.85403 53.008V53.77C9.77803 53.809 9.67702 53.847 9.55502 53.886C9.43302 53.925 9.29404 53.959 9.14104 53.987C8.98704 54.016 8.82003 54.039 8.64403 54.054C8.46603 54.071 8.28403 54.079 8.09703 54.079C7.71203 54.079 7.37004 54.035 7.07004 53.948C6.77004 53.862 6.51903 53.715 6.31203 53.505C6.10603 53.295 5.95002 53.019 5.84402 52.675C5.73802 52.33 5.68503 51.898 5.68503 51.377C5.68503 50.854 5.73802 50.423 5.84402 50.079C5.95002 49.734 6.10504 49.457 6.30704 49.248C6.50904 49.039 6.75803 48.89 7.05003 48.804C7.34303 48.718 7.67603 48.674 8.05003 48.674C8.49503 48.674 8.85304 48.74 9.12604 48.872C9.39904 49.004 9.61003 49.175 9.75803 49.384C9.90703 49.593 10.006 49.828 10.057 50.088C10.109 50.347 10.134 50.603 10.134 50.854ZM9.31403 50.864C9.31403 50.664 9.30003 50.472 9.27603 50.29C9.25003 50.106 9.19303 49.946 9.10703 49.806C9.02003 49.669 8.89304 49.559 8.72504 49.479C8.55804 49.398 8.33303 49.358 8.05003 49.358C7.74703 49.358 7.50203 49.397 7.31203 49.474C7.12203 49.552 6.97203 49.664 6.86203 49.811C6.75203 49.96 6.67504 50.139 6.63004 50.353C6.58504 50.565 6.55902 50.803 6.55302 51.066L9.31403 50.864Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M14.239 50.671H11.39V51.365H14.239V50.671Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M17.924 54.078C17.538 54.078 17.196 54.034 16.897 53.947C16.597 53.86 16.345 53.713 16.139 53.505C15.933 53.294 15.777 53.017 15.671 52.675C15.565 52.33 15.512 51.896 15.512 51.376C15.512 50.854 15.565 50.423 15.671 50.077C15.777 49.733 15.933 49.456 16.139 49.247C16.345 49.038 16.597 48.89 16.897 48.803C17.196 48.717 17.538 48.673 17.924 48.673C18.215 48.673 18.476 48.692 18.711 48.731C18.946 48.769 19.137 48.815 19.286 48.866V49.629C19.093 49.558 18.887 49.501 18.668 49.46C18.449 49.419 18.204 49.397 17.934 49.397C17.645 49.397 17.403 49.43 17.21 49.493C17.017 49.558 16.861 49.666 16.737 49.816C16.615 49.968 16.528 50.171 16.477 50.425C16.426 50.679 16.399 50.999 16.399 51.385C16.399 51.765 16.426 52.08 16.477 52.332C16.528 52.582 16.615 52.783 16.737 52.934C16.861 53.086 17.019 53.192 17.216 53.254C17.412 53.314 17.654 53.345 17.944 53.345C18.188 53.345 18.43 53.327 18.668 53.292C18.906 53.257 19.118 53.199 19.305 53.123V53.885C19.235 53.91 19.146 53.935 19.039 53.958C18.933 53.979 18.818 54.001 18.693 54.02C18.567 54.04 18.438 54.054 18.307 54.063C18.174 54.073 18.046 54.078 17.924 54.078Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M22.722 54.078C22.336 54.078 21.993 54.034 21.694 53.947C21.395 53.86 21.142 53.713 20.937 53.504C20.731 53.295 20.575 53.019 20.468 52.674C20.361 52.33 20.309 51.896 20.309 51.376C20.309 50.854 20.361 50.423 20.468 50.077C20.575 49.733 20.731 49.456 20.937 49.247C21.142 49.038 21.395 48.89 21.694 48.803C21.993 48.717 22.336 48.673 22.722 48.673C23.108 48.673 23.451 48.717 23.75 48.803C24.048 48.89 24.3 49.038 24.502 49.247C24.705 49.456 24.86 49.733 24.965 50.077C25.072 50.423 25.125 50.854 25.125 51.376C25.125 51.896 25.072 52.33 24.965 52.674C24.86 53.019 24.705 53.295 24.502 53.504C24.3 53.713 24.048 53.86 23.75 53.947C23.451 54.034 23.108 54.078 22.722 54.078ZM22.722 53.373C23.017 53.373 23.264 53.342 23.46 53.277C23.657 53.213 23.813 53.103 23.929 52.95C24.044 52.794 24.125 52.588 24.174 52.331C24.222 52.074 24.247 51.755 24.247 51.376C24.247 50.996 24.221 50.677 24.169 50.42C24.118 50.162 24.034 49.957 23.913 49.803C23.794 49.648 23.637 49.536 23.442 49.47C23.244 49.402 23.005 49.368 22.722 49.368C22.431 49.368 22.189 49.402 21.993 49.47C21.797 49.536 21.639 49.648 21.521 49.803C21.401 49.957 21.318 50.162 21.269 50.42C21.221 50.677 21.197 50.996 21.197 51.376C21.197 51.755 21.223 52.074 21.274 52.331C21.326 52.588 21.411 52.794 21.534 52.95C21.658 53.103 21.814 53.213 22.007 53.277C22.201 53.342 22.438 53.373 22.722 53.373Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M32.056 48.673C32.358 48.673 32.618 48.715 32.832 48.799C33.048 48.882 33.225 49 33.365 49.152C33.501 49.303 33.604 49.483 33.668 49.692C33.732 49.901 33.764 50.13 33.764 50.382V53.982H32.934V50.681C32.934 50.276 32.865 49.963 32.727 49.744C32.588 49.526 32.323 49.416 31.93 49.416C31.776 49.416 31.629 49.429 31.491 49.456C31.353 49.481 31.226 49.527 31.111 49.595C30.994 49.662 30.891 49.756 30.801 49.875C30.71 49.993 30.637 50.147 30.579 50.333V50.372V53.982H29.749V50.681C29.749 50.282 29.684 49.972 29.556 49.749C29.426 49.527 29.172 49.416 28.793 49.416C28.633 49.416 28.481 49.428 28.339 49.45C28.198 49.473 28.069 49.518 27.953 49.585C27.837 49.652 27.735 49.749 27.645 49.875C27.554 50 27.477 50.163 27.412 50.362V53.982H26.582V48.77H27.412V49.456C27.573 49.147 27.785 48.939 28.05 48.832C28.314 48.726 28.603 48.673 28.919 48.673C29.33 48.673 29.659 48.749 29.904 48.9C30.148 49.052 30.324 49.259 30.434 49.523C30.511 49.356 30.61 49.217 30.728 49.108C30.847 48.998 30.98 48.911 31.123 48.847C31.27 48.782 31.42 48.737 31.577 48.712C31.736 48.687 31.895 48.673 32.056 48.673Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M40.945 48.673C41.247 48.673 41.507 48.715 41.722 48.799C41.937 48.882 42.114 49 42.254 49.152C42.39 49.303 42.493 49.483 42.557 49.692C42.621 49.901 42.653 50.13 42.653 50.382V53.982H41.823V50.681C41.823 50.276 41.754 49.963 41.616 49.744C41.477 49.526 41.212 49.416 40.819 49.416C40.665 49.416 40.518 49.429 40.38 49.456C40.242 49.481 40.115 49.527 40 49.595C39.883 49.662 39.78 49.756 39.69 49.875C39.599 49.993 39.526 50.147 39.468 50.333V50.372V53.982H38.638V50.681C38.638 50.282 38.574 49.972 38.445 49.749C38.315 49.527 38.061 49.416 37.682 49.416C37.521 49.416 37.371 49.428 37.228 49.45C37.087 49.473 36.958 49.518 36.842 49.585C36.727 49.652 36.624 49.749 36.534 49.875C36.443 50 36.366 50.163 36.301 50.362V53.982H35.471V48.77H36.301V49.456C36.463 49.147 36.674 48.939 36.939 48.832C37.203 48.726 37.492 48.673 37.808 48.673C38.219 48.673 38.548 48.749 38.793 48.9C39.037 49.052 39.214 49.259 39.323 49.523C39.4 49.356 39.499 49.217 39.618 49.108C39.736 48.998 39.869 48.911 40.012 48.847C40.159 48.782 40.309 48.737 40.466 48.712C40.625 48.687 40.784 48.673 40.945 48.673Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M48.5011 50.854C48.5011 50.927 48.4971 51.014 48.4881 51.121C48.4771 51.227 48.467 51.342 48.453 51.464L44.92 51.684C44.92 51.969 44.951 52.215 45.008 52.424C45.066 52.634 45.16 52.805 45.287 52.94C45.416 53.074 45.587 53.177 45.799 53.244C46.011 53.312 46.276 53.345 46.59 53.345C46.88 53.345 47.174 53.313 47.474 53.249C47.773 53.184 48.023 53.104 48.221 53.008V53.77C48.145 53.809 48.045 53.847 47.922 53.886C47.8 53.925 47.662 53.959 47.508 53.987C47.354 54.016 47.187 54.039 47.011 54.054C46.833 54.071 46.652 54.079 46.465 54.079C46.079 54.079 45.737 54.035 45.438 53.948C45.138 53.862 44.886 53.715 44.679 53.505C44.473 53.295 44.317 53.019 44.211 52.675C44.106 52.33 44.053 51.898 44.053 51.377C44.053 50.854 44.106 50.423 44.211 50.079C44.317 49.734 44.472 49.457 44.675 49.248C44.877 49.039 45.1251 48.89 45.4171 48.804C45.7101 48.718 46.0431 48.674 46.4171 48.674C46.8621 48.674 47.22 48.74 47.494 48.872C47.766 49.004 47.977 49.175 48.125 49.384C48.274 49.593 48.373 49.828 48.424 50.088C48.478 50.347 48.5011 50.603 48.5011 50.854ZM47.6821 50.864C47.6821 50.664 47.669 50.472 47.644 50.29C47.618 50.106 47.5621 49.946 47.4751 49.806C47.3881 49.669 47.261 49.559 47.093 49.479C46.926 49.398 46.701 49.358 46.418 49.358C46.116 49.358 45.87 49.397 45.68 49.474C45.49 49.552 45.34 49.664 45.231 49.811C45.12 49.96 45.043 50.139 44.999 50.353C44.953 50.565 44.9271 50.803 44.9211 51.066L47.6821 50.864Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M52.5271 48.673L52.499 49.426H52.382C52.215 49.426 52.051 49.443 51.89 49.475C51.729 49.506 51.5791 49.567 51.4361 49.652C51.2961 49.739 51.167 49.858 51.05 50.005C50.935 50.153 50.841 50.343 50.771 50.574V53.982H49.941V48.77H50.771V49.716C50.854 49.496 50.958 49.319 51.08 49.185C51.202 49.049 51.338 48.943 51.485 48.866C51.632 48.788 51.789 48.737 51.954 48.712C52.117 48.687 52.276 48.673 52.431 48.673H52.5271V48.673Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M55.52 54.078C55.134 54.078 54.791 54.034 54.493 53.947C54.194 53.86 53.94 53.713 53.734 53.505C53.529 53.294 53.373 53.017 53.266 52.675C53.16 52.33 53.107 51.896 53.107 51.376C53.107 50.854 53.16 50.423 53.266 50.077C53.373 49.733 53.529 49.456 53.734 49.247C53.94 49.038 54.194 48.89 54.493 48.803C54.791 48.717 55.134 48.673 55.52 48.673C55.811 48.673 56.072 48.692 56.307 48.731C56.541 48.769 56.733 48.815 56.881 48.866V49.629C56.688 49.558 56.482 49.501 56.264 49.46C56.044 49.419 55.8 49.397 55.53 49.397C55.241 49.397 54.999 49.43 54.806 49.493C54.613 49.558 54.456 49.666 54.333 49.816C54.21 49.968 54.124 50.171 54.073 50.425C54.021 50.679 53.995 50.999 53.995 51.385C53.995 51.765 54.021 52.08 54.073 52.332C54.124 52.582 54.21 52.783 54.333 52.934C54.456 53.086 54.614 53.192 54.811 53.254C55.007 53.314 55.25 53.345 55.54 53.345C55.784 53.345 56.026 53.327 56.264 53.292C56.501 53.257 56.714 53.199 56.901 53.123V53.885C56.831 53.91 56.741 53.935 56.635 53.958C56.528 53.979 56.414 54.001 56.288 54.02C56.162 54.04 56.034 54.054 55.902 54.063C55.77 54.073 55.643 54.078 55.52 54.078Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M62.353 50.854C62.353 50.927 62.348 51.014 62.339 51.121C62.329 51.227 62.318 51.342 62.304 51.464L58.772 51.684C58.772 51.969 58.802 52.215 58.859 52.424C58.917 52.634 59.011 52.805 59.139 52.94C59.267 53.074 59.438 53.177 59.651 53.244C59.863 53.312 60.127 53.345 60.442 53.345C60.731 53.345 61.025 53.313 61.325 53.249C61.625 53.184 61.874 53.104 62.073 53.008V53.77C61.996 53.809 61.896 53.847 61.774 53.886C61.652 53.925 61.514 53.959 61.359 53.987C61.205 54.016 61.039 54.039 60.862 54.054C60.684 54.071 60.504 54.079 60.316 54.079C59.93 54.079 59.588 54.035 59.289 53.948C58.99 53.862 58.737 53.715 58.531 53.505C58.325 53.295 58.17 53.019 58.062 52.675C57.957 52.33 57.904 51.898 57.904 51.377C57.904 50.854 57.957 50.423 58.062 50.079C58.17 49.734 58.323 49.457 58.526 49.248C58.729 49.039 58.977 48.89 59.269 48.804C59.562 48.718 59.894 48.674 60.268 48.674C60.713 48.674 61.071 48.74 61.345 48.872C61.618 49.004 61.828 49.175 61.977 49.384C62.125 49.593 62.225 49.828 62.276 50.088C62.328 50.347 62.353 50.603 62.353 50.854ZM61.533 50.864C61.533 50.664 61.52 50.472 61.494 50.29C61.469 50.106 61.412 49.946 61.325 49.806C61.239 49.669 61.112 49.559 60.944 49.479C60.776 49.398 60.552 49.358 60.268 49.358C59.967 49.358 59.72 49.397 59.53 49.474C59.34 49.552 59.19 49.664 59.081 49.811C58.971 49.96 58.894 50.139 58.849 50.353C58.804 50.565 58.778 50.803 58.772 51.066L61.533 50.864Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M72.893 50.854C72.893 50.927 72.888 51.014 72.879 51.121C72.869 51.227 72.858 51.342 72.844 51.464L69.312 51.684C69.312 51.969 69.342 52.215 69.4 52.424C69.457 52.634 69.551 52.805 69.679 52.94C69.807 53.074 69.978 53.177 70.19 53.244C70.403 53.312 70.667 53.345 70.982 53.345C71.271 53.345 71.566 53.313 71.866 53.249C72.164 53.184 72.414 53.104 72.613 53.008V53.77C72.537 53.809 72.436 53.847 72.313 53.886C72.191 53.925 72.053 53.959 71.9 53.987C71.745 54.016 71.579 54.039 71.402 54.054C71.224 54.071 71.043 54.079 70.856 54.079C70.47 54.079 70.128 54.035 69.829 53.948C69.529 53.862 69.277 53.715 69.07 53.505C68.865 53.295 68.709 53.019 68.602 52.675C68.497 52.33 68.444 51.898 68.444 51.377C68.444 50.854 68.497 50.423 68.602 50.079C68.709 49.734 68.863 49.457 69.066 49.248C69.268 49.039 69.516 48.89 69.809 48.804C70.102 48.718 70.435 48.674 70.808 48.674C71.254 48.674 71.611 48.74 71.885 48.872C72.157 49.004 72.369 49.175 72.517 49.384C72.665 49.593 72.764 49.828 72.816 50.088C72.868 50.347 72.893 50.603 72.893 50.854ZM72.073 50.864C72.073 50.664 72.059 50.472 72.034 50.29C72.008 50.106 71.952 49.946 71.866 49.806C71.778 49.669 71.652 49.559 71.483 49.479C71.317 49.398 71.092 49.358 70.808 49.358C70.506 49.358 70.26 49.397 70.07 49.474C69.88 49.552 69.73 49.664 69.621 49.811C69.511 49.96 69.434 50.139 69.389 50.353C69.344 50.565 69.318 50.803 69.312 51.066L72.073 50.864Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M73.55 48.77H74.39L75.972 53.151H76.031L77.556 48.77H78.435L76.485 53.981H75.5L73.55 48.77Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M81.416 54.078C81.03 54.078 80.687 54.034 80.389 53.947C80.089 53.86 79.836 53.713 79.63 53.504C79.425 53.295 79.269 53.019 79.162 52.674C79.056 52.33 79.003 51.896 79.003 51.376C79.003 50.854 79.056 50.423 79.162 50.077C79.269 49.733 79.425 49.456 79.63 49.247C79.836 49.038 80.089 48.89 80.389 48.803C80.687 48.717 81.03 48.673 81.416 48.673C81.802 48.673 82.145 48.717 82.444 48.803C82.743 48.89 82.994 49.038 83.197 49.247C83.4 49.456 83.554 49.733 83.66 50.077C83.767 50.423 83.819 50.854 83.819 51.376C83.819 51.896 83.767 52.33 83.66 52.674C83.554 53.019 83.4 53.295 83.197 53.504C82.994 53.713 82.743 53.86 82.444 53.947C82.145 54.034 81.802 54.078 81.416 54.078ZM81.416 53.373C81.712 53.373 81.958 53.342 82.154 53.277C82.351 53.213 82.507 53.103 82.623 52.95C82.738 52.794 82.82 52.588 82.869 52.331C82.916 52.074 82.941 51.755 82.941 51.376C82.941 50.996 82.916 50.677 82.864 50.42C82.812 50.162 82.728 49.957 82.607 49.803C82.489 49.648 82.331 49.536 82.136 49.47C81.938 49.402 81.7 49.368 81.416 49.368C81.126 49.368 80.883 49.402 80.687 49.47C80.491 49.536 80.333 49.648 80.215 49.803C80.095 49.957 80.012 50.162 79.963 50.42C79.916 50.677 79.891 50.996 79.891 51.376C79.891 51.755 79.917 52.074 79.969 52.331C80.02 52.588 80.106 52.794 80.229 52.95C80.353 53.103 80.509 53.213 80.701 53.277C80.895 53.342 81.133 53.373 81.416 53.373Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M86.436 54.04C86.05 54.04 85.76 53.953 85.567 53.778C85.374 53.605 85.278 53.322 85.278 52.93V46.646H86.108V52.718C86.108 52.981 86.146 53.151 86.224 53.229C86.3 53.307 86.422 53.345 86.59 53.345C86.648 53.345 86.711 53.342 86.779 53.335C86.846 53.328 86.915 53.315 86.985 53.297V53.981C86.909 54.001 86.827 54.016 86.74 54.024C86.652 54.034 86.55 54.04 86.436 54.04Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M92.198 48.77V53.982H91.493L91.386 53.23C91.31 53.404 91.21 53.544 91.088 53.655C90.966 53.763 90.832 53.848 90.687 53.91C90.543 53.971 90.389 54.014 90.229 54.041C90.068 54.066 89.907 54.079 89.745 54.079C89.405 54.079 89.122 54.037 88.896 53.954C88.671 53.871 88.492 53.753 88.361 53.606C88.229 53.457 88.136 53.279 88.081 53.071C88.026 52.861 87.999 52.631 87.999 52.38V48.77H88.829V52.071C88.829 52.271 88.842 52.45 88.868 52.607C88.893 52.764 88.942 52.898 89.017 53.007C89.092 53.117 89.194 53.2 89.326 53.258C89.458 53.317 89.627 53.345 89.834 53.345C89.993 53.345 90.151 53.334 90.305 53.312C90.46 53.289 90.603 53.241 90.735 53.166C90.867 53.092 90.986 52.988 91.094 52.853C91.199 52.718 91.29 52.538 91.368 52.312V48.77H92.198V48.77Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M95.576 53.345C95.691 53.345 95.794 53.34 95.88 53.33C95.967 53.321 96.055 53.306 96.145 53.287V53.991C96.042 54.004 95.946 54.016 95.855 54.026C95.766 54.034 95.666 54.04 95.556 54.04C95.266 54.04 95.024 54.019 94.827 53.977C94.632 53.936 94.471 53.854 94.346 53.731C94.22 53.609 94.13 53.44 94.075 53.224C94.02 53.008 93.992 52.731 93.992 52.39V49.465H93.221V48.769H93.992V47.534H94.822V48.769H96.116V49.465H94.822V52.341C94.822 52.547 94.832 52.714 94.851 52.843C94.871 52.972 94.908 53.074 94.964 53.147C95.017 53.221 95.094 53.273 95.19 53.301C95.286 53.33 95.415 53.345 95.576 53.345Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M97.632 47.813C97.445 47.813 97.315 47.785 97.241 47.728C97.168 47.67 97.131 47.534 97.131 47.321C97.131 47.104 97.168 46.965 97.241 46.911C97.315 46.856 97.445 46.829 97.632 46.829C97.806 46.829 97.932 46.856 98.008 46.911C98.085 46.965 98.124 47.104 98.124 47.321C98.124 47.534 98.085 47.67 98.008 47.728C97.932 47.785 97.806 47.813 97.632 47.813ZM97.207 48.77H98.037V53.982H97.207V48.77Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M101.898 54.078C101.512 54.078 101.169 54.034 100.87 53.947C100.571 53.86 100.318 53.713 100.112 53.504C99.907 53.295 99.751 53.019 99.644 52.674C99.537 52.33 99.485 51.896 99.485 51.376C99.485 50.854 99.537 50.423 99.644 50.077C99.751 49.733 99.907 49.456 100.112 49.247C100.318 49.038 100.571 48.89 100.87 48.803C101.169 48.717 101.512 48.673 101.898 48.673C102.284 48.673 102.626 48.717 102.925 48.803C103.225 48.89 103.476 49.038 103.678 49.247C103.881 49.456 104.035 49.733 104.141 50.077C104.247 50.423 104.301 50.854 104.301 51.376C104.301 51.896 104.247 52.33 104.141 52.674C104.036 53.019 103.881 53.295 103.678 53.504C103.476 53.713 103.225 53.86 102.925 53.947C102.626 54.034 102.284 54.078 101.898 54.078ZM101.898 53.373C102.193 53.373 102.439 53.342 102.636 53.277C102.832 53.213 102.989 53.103 103.105 52.95C103.219 52.794 103.301 52.588 103.35 52.331C103.398 52.074 103.423 51.755 103.423 51.376C103.423 50.996 103.396 50.677 103.345 50.42C103.293 50.162 103.209 49.957 103.089 49.803C102.97 49.648 102.812 49.536 102.616 49.47C102.419 49.402 102.18 49.368 101.897 49.368C101.607 49.368 101.364 49.402 101.168 49.47C100.971 49.536 100.813 49.648 100.695 49.803C100.576 49.957 100.493 50.162 100.444 50.42C100.397 50.677 100.372 50.996 100.372 51.376C100.372 51.755 100.397 52.074 100.449 52.331C100.501 52.588 100.586 52.794 100.71 52.95C100.832 53.103 100.989 53.213 101.182 53.277C101.377 53.342 101.614 53.373 101.898 53.373Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M108.259 48.673C108.601 48.673 108.883 48.715 109.108 48.799C109.334 48.882 109.512 49 109.645 49.152C109.777 49.303 109.87 49.481 109.924 49.686C109.979 49.893 110.006 50.12 110.006 50.372V53.982H109.167V50.681C109.167 50.482 109.153 50.303 109.128 50.146C109.102 49.986 109.052 49.856 108.978 49.749C108.905 49.643 108.803 49.561 108.675 49.503C108.546 49.445 108.377 49.416 108.172 49.416C108.004 49.416 107.843 49.428 107.685 49.45C107.528 49.473 107.38 49.521 107.242 49.595C107.103 49.669 106.978 49.773 106.864 49.909C106.753 50.044 106.661 50.228 106.59 50.459V53.982H105.76V48.77H106.59V49.513C106.668 49.346 106.769 49.207 106.894 49.098C107.02 48.988 107.156 48.903 107.305 48.843C107.452 48.781 107.609 48.737 107.773 48.712C107.937 48.687 108.098 48.673 108.259 48.673Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M112.148 47.813C111.961 47.813 111.832 47.785 111.758 47.728C111.684 47.67 111.647 47.534 111.647 47.321C111.647 47.104 111.684 46.965 111.758 46.911C111.831 46.856 111.961 46.829 112.148 46.829C112.322 46.829 112.447 46.856 112.525 46.911C112.601 46.965 112.64 47.104 112.64 47.321C112.64 47.534 112.601 47.67 112.525 47.728C112.447 47.785 112.322 47.813 112.148 47.813ZM111.725 48.77H112.555V53.982H111.725V48.77Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M115.518 54.04C115.388 54.04 115.252 54.034 115.107 54.024C114.962 54.016 114.82 54.004 114.678 53.991C114.536 53.978 114.406 53.962 114.286 53.937C114.168 53.916 114.072 53.894 114.002 53.876V53.161C114.092 53.187 114.199 53.213 114.325 53.238C114.451 53.264 114.581 53.286 114.716 53.307C114.852 53.325 114.988 53.34 115.127 53.35C115.265 53.359 115.392 53.364 115.508 53.364C115.906 53.364 116.208 53.308 116.41 53.194C116.613 53.083 116.715 52.872 116.715 52.562C116.715 52.409 116.699 52.281 116.671 52.182C116.643 52.081 116.585 51.998 116.502 51.931C116.418 51.863 116.301 51.803 116.15 51.752C115.998 51.701 115.796 51.646 115.546 51.588C115.256 51.523 115.019 51.45 114.832 51.366C114.644 51.282 114.496 51.184 114.389 51.066C114.279 50.951 114.202 50.813 114.157 50.652C114.112 50.491 114.09 50.301 114.09 50.082C114.09 49.657 114.247 49.316 114.558 49.059C114.871 48.802 115.338 48.673 115.963 48.673C116.213 48.673 116.462 48.688 116.71 48.721C116.957 48.753 117.147 48.795 117.274 48.847L117.217 49.551C117.069 49.493 116.886 49.445 116.666 49.406C116.447 49.367 116.215 49.349 115.971 49.349C115.605 49.349 115.33 49.399 115.146 49.503C114.962 49.606 114.872 49.806 114.872 50.102C114.872 50.236 114.887 50.347 114.916 50.43C114.944 50.513 114.994 50.586 115.064 50.646C115.134 50.708 115.235 50.76 115.364 50.801C115.493 50.844 115.659 50.887 115.866 50.933C116.161 51.003 116.415 51.078 116.622 51.158C116.832 51.239 117.001 51.34 117.131 51.458C117.26 51.577 117.353 51.723 117.411 51.896C117.468 52.07 117.497 52.283 117.497 52.534C117.497 53.056 117.328 53.436 116.99 53.678C116.651 53.919 116.16 54.04 115.518 54.04Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M124.407 48.673C124.709 48.673 124.969 48.715 125.184 48.799C125.399 48.882 125.576 49 125.715 49.152C125.852 49.303 125.954 49.483 126.019 49.692C126.082 49.901 126.115 50.13 126.115 50.382V53.982H125.285V50.681C125.285 50.276 125.216 49.963 125.078 49.744C124.939 49.526 124.674 49.416 124.281 49.416C124.127 49.416 123.98 49.429 123.843 49.456C123.704 49.481 123.577 49.527 123.462 49.595C123.345 49.662 123.242 49.756 123.152 49.875C123.061 49.993 122.988 50.147 122.929 50.333V50.372V53.982H122.1V50.681C122.1 50.282 122.036 49.972 121.907 49.749C121.777 49.527 121.523 49.416 121.144 49.416C120.984 49.416 120.832 49.428 120.69 49.45C120.548 49.473 120.42 49.518 120.303 49.585C120.189 49.652 120.086 49.749 119.995 49.875C119.905 50 119.828 50.163 119.763 50.362V53.982H118.933V48.77H119.763V49.456C119.924 49.147 120.135 48.939 120.401 48.832C120.665 48.726 120.954 48.673 121.27 48.673C121.681 48.673 122.01 48.749 122.254 48.9C122.498 49.052 122.675 49.259 122.784 49.523C122.861 49.356 122.96 49.217 123.079 49.108C123.198 48.998 123.33 48.911 123.474 48.847C123.62 48.782 123.771 48.737 123.927 48.712C124.087 48.687 124.246 48.673 124.407 48.673Z"
                          fill="#00AEEF"
                          stroke="#00AEEF"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M6.03705 40.236V19.093H14.056C16.233 19.093 18.061 19.695 19.54 20.9C22.076 22.972 23.344 25.877 23.344 29.617C23.344 31.731 22.9101 33.606 22.0441 35.244C21.1781 36.882 19.942 38.155 18.336 39.064C16.961 39.845 15.007 40.236 12.471 40.236H6.03705ZM10.506 36.21H13.36C14.521 36.21 15.483 35.957 16.243 35.45C17.955 34.288 18.812 32.302 18.812 29.49C18.812 26.913 17.9761 25.042 16.3071 23.88C15.5681 23.373 14.616 23.119 13.454 23.119H10.506V36.21Z"
                          fill="black"
                          stroke="black"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M40.523 40.237H36.18V38.968C34.701 40.089 33.19 40.649 31.647 40.649C29.598 40.649 27.865 39.845 26.449 38.239C25.033 36.633 24.325 34.678 24.325 32.375C24.325 30.114 25.054 28.218 26.512 26.685C27.971 25.154 29.777 24.388 31.933 24.388C33.391 24.388 34.806 24.916 36.18 25.972V24.799H40.523V40.237ZM32.44 28.635C31.404 28.635 30.517 29.01 29.777 29.76C29.038 30.51 28.669 31.413 28.669 32.47C28.669 33.506 29.033 34.394 29.761 35.133C30.491 35.873 31.373 36.242 32.408 36.242C33.464 36.242 34.363 35.873 35.103 35.133C35.842 34.394 36.212 33.495 36.212 32.439C36.212 31.404 35.842 30.51 35.103 29.76C34.363 29.01 33.476 28.635 32.44 28.635Z"
                          fill="black"
                          stroke="black"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M43.122 40.236V24.799H47.465V26.923C48.394 25.38 49.663 24.609 51.268 24.609C51.649 24.609 51.976 24.673 52.251 24.799V28.634C51.025 28.655 50.212 28.718 49.81 28.824C48.246 29.205 47.465 30.303 47.465 32.121V40.236H43.122Z"
                          fill="black"
                          stroke="black"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M63.612 40.237H59.137L53.145 24.799H57.615L61.101 33.77L63.612 40.237ZM60.616 24.799H65.026L68.323 33.77L71.904 24.799H76.31L69.812 40.237H66.388L63.156 31.424L60.616 24.799Z"
                          fill="black"
                          stroke="black"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M82.437 39L76.319 24.799H81.138L84.94 33.579L89.092 24.799H93.786L83.769 45.941H79.235L82.437 39Z"
                          fill="black"
                          stroke="black"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M94.641 40.236V24.799H98.983V26.542C100.484 25.105 102.078 24.386 103.77 24.386C104.889 24.386 105.888 24.667 106.765 25.227C107.642 25.787 108.271 26.532 108.651 27.462C108.947 28.202 109.095 29.299 109.095 30.757V40.236H104.751V31.328C104.751 29.469 103.906 28.54 102.216 28.54C101.223 28.54 100.436 28.803 99.855 29.332C99.273 29.86 98.983 30.579 98.983 31.487V40.236H94.641V40.236Z"
                          fill="black"
                          stroke="black"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M111.661 40.236V24.799H116.005V26.542C117.504 25.105 119.099 24.386 120.79 24.386C121.91 24.386 122.909 24.667 123.786 25.227C124.663 25.787 125.292 26.532 125.672 27.462C125.968 28.202 126.115 29.299 126.115 30.757V40.236H121.773V31.328C121.773 29.469 120.927 28.54 119.237 28.54C118.243 28.54 117.457 28.803 116.876 29.332C116.294 29.86 116.005 30.579 116.005 31.487V40.236H111.661V40.236Z"
                          fill="black"
                          stroke="black"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M196.899 3.76096C196.26 3.24496 195.436 3.04799 194.634 3.21699L181.069 6.08799C179.826 6.35099 178.923 7.46496 178.923 8.73496V18.099C178.923 19.592 180.137 20.805 181.629 20.805H195.194C196.686 20.805 197.9 19.592 197.9 18.099V5.86399C197.901 5.04499 197.536 4.27796 196.899 3.76096ZM196.372 5.86399V18.099C196.372 18.748 195.844 19.276 195.195 19.276H181.63C180.982 19.276 180.453 18.748 180.453 18.099V8.73496C180.453 8.18196 180.846 7.69799 181.386 7.58399L194.951 4.71299C195.032 4.69599 195.115 4.68699 195.197 4.68699C195.465 4.68699 195.727 4.77999 195.936 4.94999C196.213 5.17499 196.372 5.50799 196.372 5.86399Z"
                          fill="#44C8F5"
                          stroke="#44C8F5"
                          initial="from"
                          animate="to"
                          variants={pathPointer}
                      />
                      <motion.path
                          d="M210.049 -3.08502H-7.95099V60.915H210.049V-3.08502Z"
                          stroke="#E0E1E2"
                          strokeMiterlimit="20"
                          initial="from"
                          animate="to"
                          variants={pathWordVariants}
                      />
                      <motion.path
                          d="M168.576 22.321C168.66 22.279 168.792 22.225 168.955 22.159C170.08 21.696 172.714 20.614 172.584 18.51C172.51 17.324 171.779 16.619 171.135 15.996C170.651 15.53 170.227 15.12 170.063 14.55C171.177 13.191 171.497 12.009 171.011 11.038C169.578 8.17497 165.906 7.86997 163.149 9.24897C161.36 10.145 158.909 11.371 157.923 13.342C157.447 14.292 157.255 15.306 157.069 16.286C156.833 17.527 156.61 18.699 155.825 19.484C154.179 21.13 152.262 22.554 150.41 23.931C147.86 25.826 145.223 27.785 143.121 30.412C140.909 33.179 138.426 37.176 138.09 40.104C137.618 44.213 138.073 46.666 139.829 49.476C139.984 49.724 140.31 49.799 140.558 49.644C140.805 49.49 140.881 49.162 140.726 48.915C139.115 46.336 138.107 42.215 139.932 38.81C141.695 35.52 142.535 34.856 145.199 31.526C147.216 29.005 149.407 27.198 151.708 25.106C153.603 23.384 154.873 21.933 156.573 20.233C157.589 19.217 157.853 17.827 158.109 16.484C158.282 15.575 158.461 14.634 158.87 13.815C159.698 12.16 161.849 11.575 163.657 11.026C166.017 10.309 168.518 9.89297 169.642 11.512C169.896 11.878 170.271 12.661 169.172 13.966C169.165 13.973 169.159 13.982 169.153 13.989C168.949 14.141 168.095 14.711 166.656 14.831C166.365 14.856 166.148 15.112 166.173 15.403C166.195 15.679 166.428 15.888 166.7 15.888C166.714 15.888 166.729 15.887 166.744 15.886C167.835 15.795 168.649 15.485 169.178 15.21C169.465 15.857 169.69 16.21 169.977 16.758C170.408 17.582 171.055 17.8 171.104 18.575C171.188 19.922 169.468 20.803 168.553 21.179C168.359 21.259 168.202 21.325 168.104 21.373C167.773 21.538 167.512 21.907 167.327 22.464C166.837 23.926 167.317 25.932 167.427 26.267C167.945 27.865 168.538 30.306 168.669 31.881C168.769 33.066 168.531 35.303 168.256 37.894C167.512 44.9 167.084 50.455 168.978 52.306C168.079 52.411 166.417 52.409 165.411 52.406C164.988 52.405 164.587 52.404 164.233 52.407H164.231C163.633 52.407 162.966 49.949 162.747 49.14C162.601 48.597 162.483 48.169 162.364 47.89C162.022 47.093 161.785 46.215 161.63 45.31C162.69 44.82 163.505 44.219 164.084 43.684C166.456 41.494 166.655 37.402 164.822 35.57C164.316 35.063 163.698 34.889 163.08 35.077C161.807 35.467 160.909 36.382 160.321 38.274C159.803 39.941 160.195 42.379 160.471 44.672C160.436 44.688 160.402 44.703 160.367 44.719C158.869 45.388 156.607 46.019 156.062 46.924C154.393 49.697 157.216 51.524 158.408 52.442C155.725 52.582 149.441 52.841 147.934 51.585C147.607 51.312 147.345 50.971 147.145 50.577C151.359 48.134 155.002 43.197 156.194 39.235C156.827 37.131 157.103 34.649 156.436 33.694C156.074 33.174 155.632 32.829 155.054 32.764C153.45 32.58 150.206 34.097 147.909 37.572C146.269 40.051 144.724 46.171 145.84 50.083C144.589 50.704 143.334 51.069 142.158 51.072H142.137C140.128 51.072 138.178 50.233 136.651 48.981C129.621 43.22 130.554 36.119 131.102 33.335C131.533 31.141 132.482 27.349 134.935 23.882C136.818 21.222 139.515 17.95 143.712 17.46C144.275 17.378 145.557 17.371 145.923 17.868C146.095 18.102 146.427 18.153 146.662 17.979C146.897 17.806 146.948 17.474 146.774 17.239C145.934 16.1 143.798 16.375 143.575 16.411C135.563 17.344 130.269 27.762 129.217 33.131C128.634 36.103 128.084 43.676 135.557 49.799C137.286 51.217 139.867 52.13 142.136 52.13H142.16C143.469 52.126 144.85 51.737 146.219 51.07C146.479 51.586 146.821 52.036 147.255 52.398C148.399 53.351 151.212 53.62 154.312 53.62C155.842 53.62 157.444 53.554 158.947 53.473L159.277 53.454C159.47 53.445 159.988 53.417 160.124 52.969C160.263 52.506 159.885 52.225 159.361 51.835C157.902 50.75 156.581 49.52 157.815 47.47C158.171 46.877 159.456 46.285 160.636 45.757C160.804 46.649 161.05 47.513 161.39 48.306C161.48 48.518 161.598 48.954 161.724 49.417C162.215 51.227 162.82 53.473 164.243 53.465C164.593 53.462 164.989 53.462 165.407 53.464C169.184 53.476 170.23 53.376 170.439 52.662C170.509 52.42 170.479 52.059 169.933 51.712C167.984 50.476 169.627 42.971 170.155 38.006C170.435 35.362 170.654 33.079 170.571 31.794C170.351 28.371 168.283 25.133 168.208 23.931C168.181 23.509 168.224 23.127 168.332 22.796C168.439 22.469 168.549 22.34 168.576 22.321ZM146.778 49.569C145.92 46.075 148.363 40.502 149.581 38.233C151.254 35.118 154.212 33.516 155.053 33.516C155.093 33.516 155.13 33.518 155.166 33.522C155.322 33.54 155.553 33.603 155.759 33.945C156.342 34.916 155.667 36.966 154.739 38.993C153.166 42.427 150.659 47.245 146.778 49.569ZM161.657 38.973C161.836 38.051 162.657 35.784 163.386 35.666C163.554 35.639 163.896 35.671 164.072 35.894C165.343 37.511 164.296 40.657 163.565 41.929C162.773 43.309 162.263 43.834 161.479 44.209C161.272 42.152 161.357 40.52 161.657 38.973Z"
                          fill="black"
                          stroke='black'
                          strokeWidth="1"
                          initial="from"
                          animate="to"
                          variants={pathCheckVariants}

                      />
                      <motion.path
                          d="M169.865 25.563C169.709 25.563 169.552 25.494 169.449 25.361C169.268 25.131 169.308 24.798 169.538 24.618C170.402 23.939 171.569 23.47 172.805 22.973C174.358 22.35 175.961 21.706 176.885 20.64C177.497 19.934 178.045 18.803 178.624 17.607C179.708 15.371 180.937 12.837 183.142 11.869C185.236 10.95 187.468 10.215 188.155 11.73C188.286 12.02 188.283 12.318 188.148 12.593C187.877 13.145 187.111 13.549 185.418 14.001C185.762 14.474 186.086 15.13 185.937 15.813C185.775 16.556 185.116 17.101 183.979 17.433C183.702 17.516 183.405 17.354 183.323 17.074C183.241 16.793 183.402 16.499 183.683 16.417C184.398 16.209 184.408 15.915 184.479 15.588C184.595 15.058 184.336 14.319 184.088 14.102C183.939 13.971 183.874 13.768 183.922 13.576C183.97 13.383 184.115 13.196 184.314 13.187C186.674 13.08 187.931 12.616 187.539 11.831C187.03 10.813 184.721 11.68 183.219 12.539C181.466 13.541 180.861 15.404 179.857 17.475C179.246 18.736 179.068 20.591 178.364 21.403C177.273 22.662 174.871 23.286 173.203 23.956C172.039 24.423 170.939 24.865 170.195 25.45C170.094 25.526 169.98 25.563 169.865 25.563Z"
                          fill="black"
                          stroke='black'
                          strokeWidth="1"
                          initial="from"
                          animate="to"
                          variants={pathPointer}

                      />
                  </motion.svg>
              </Grid>
              <Card sx={{width:'350px'}}>
                  <MDBox
                      variant="gradient"
                      bgColor="info"
                      borderRadius="lg"
                      coloredShadow="info"
                      mx={2}
                      mt={-3}
                      p={2}
                      mb={1}
                      textAlign="center"
                  >
                      <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                          {t('SignInPage.Sign In')}
                      </MDTypography>
                  </MDBox>

                  <MDBox pt={4} pb={3} px={3}>
                      <MDBox component="form" role="form" noValidate onSubmit={handleSubmit(onSubmit)}>
                          <MDBox mb={2}>
                              <FormControl
                                  error = {!!errors.username}
                                  fullWidth
                                  required
                                  focused = {true}
                              >
                                  <MDInput type="text"
                                           label={t('SignInPage.Username')}
                                           required
                                           {...register("username")}
                                           error={!!errors?.username}
                                  />
                                  <FormHelperText sx={{fontWeight:'medium'}}>{errors?.username?.message}</FormHelperText>
                              </FormControl>
                          </MDBox>
                          <MDBox mb={2}>
                              <FormControl
                                  error = {!!errors.password}
                                  fullWidth
                                  required
                              >
                                  <MDInput
                                      id={'login_input'}
                                      type={showPassword?'text':'password'}
                                      label={t('SignInPage.Password')}
                                      {...register("password")}
                                      fullWidth
                                      required
                                      error={!!errors.password}
                                      InputProps={{
                                          endAdornment:
                                              <InputAdornment position="end">
                                                  <IconButton
                                                      aria-label="toggle password visibility"
                                                      onClick={handleClickShowPassword}
                                                      edge="end"
                                                  >
                                                      {showPassword ? <VisibilityOff color={darkMode?'white':'info.main'} /> : <Visibility color={darkMode?'white':'info.main'} />}
                                                  </IconButton>
                                              </InputAdornment>

                                      }}

                                  />
                                  <FormHelperText sx={{fontWeight:'medium'}}>{errors?.password?.message}</FormHelperText>

                              </FormControl>
                          </MDBox>
                          <MDBox sx={{position:'relative'}}>
                            <FormControl
                                error = {!!errors.code}
                                fullWidth
                                required
                            >
                            <MDInput
                              label={t('SignInPage.Verification')}
                              {...register("code")}
                              fullWidth
                              required
                              error={!!errors.code}
                              InputProps={{
                                endAdornment:  <InputAdornment position="end" style={{}}>
                                  <img
                                    src={img}
                                    alt={'verification code'}
                                    style={style.img}
                                    onClick={async () => await dispatch(getVerificationCode())}
                                    loading="lazy"
                                  />
                                </InputAdornment>
                              }}
                            />
                              <FormHelperText sx={{fontWeight:'medium'}}>{errors?.code?.message}</FormHelperText>
                            </FormControl>
                          </MDBox>
                          <MDBox display = "flex" alignItems="center" justifyContent = "space-between">
                              <MDBox display="flex" alignItems="center" ml={-1}>
                                  <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                                  <MDTypography
                                      variant="button"
                                      fontWeight="regular"
                                      color="text"
                                      onClick={handleSetRememberMe}
                                      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                  >
                                      &nbsp;&nbsp;{t('SignInPage.Remember me')}
                                  </MDTypography>
                              </MDBox>
                              <MDTypography
                                  variant="button"
                                  color="info"
                                  fontWeight="medium"
                                  textGradient
                                  onClick={()=>setOpenModal(true)}
                                  sx={{cursor: 'pointer'}}
                              >
                                  {t('SignInPage.Forgot Password')}?
                              </MDTypography>
                          </MDBox>

                          <MDBox mt={4} mb={1}>
                              <MDButton type="submit" variant="gradient" color="info" fullWidth disabled={isLoading}>
                                  {
                                      isLoading ?  <CircularProgress  size="20px" thickness={5}  color="inherit"/>:  t('SignInPage.Sign In')
                                  }
                              </MDButton>
                          </MDBox>

                          <MDBox mt={3} mb={1} textAlign="center">
                              <Tooltip title={t('SignInPage.Ever registered for older versions')}>
                                  <MDTypography variant="button" color="text">
                                      {t('SignInPage.Legacy user for previous release?')+" "}
                                      <MDTypography
                                          component={Link}
                                          to="/authentication/legacy-sign-up"
                                          variant="button"
                                          color="info"
                                          fontWeight="medium"
                                          textGradient
                                      >
                                          {t('SignInPage.Sign Up')}
                                      </MDTypography>
                                  </MDTypography>
                              </Tooltip>
                          </MDBox>
                          {
                              process.env.REACT_APP_SIGN_UP_SHOWING === 'true' &&
                              <MDBox mb={1} textAlign="center">
                                  <Tooltip title={t('SignInPage.Never registered for any versions')}>
                                      <MDTypography variant="button" color="text">
                                          {t('SignInPage.Don\'t have an account')+"? "}
                                          <MDTypography
                                              component={Link}
                                              to="/authentication/sign-up"
                                              variant="button"
                                              color="info"
                                              fontWeight="medium"
                                              textGradient
                                          >
                                              {t('SignInPage.Sign Up')}
                                          </MDTypography>
                                      </MDTypography>
                                  </Tooltip>
                              </MDBox>
                          }
                      </MDBox>
                  </MDBox>
                  <MDBox>
                      <ForgetPasswordDialog openModal={openModal} setOpenModal={setOpenModal} />
                  </MDBox>

              </Card>
          </BasicLayout>
          <LoginVerification loginVerificationOpen={loginVerificationOpen} setLoginVerificationOpen={setLoginVerificationOpen} onLoginSuccess={onLoginSuccess} email={email}/>
      </React.Fragment>
  );
}

export default Basic;
